const details = document.querySelectorAll('.js-product-details');

details.forEach((elem) => {
  const expanders = elem.querySelectorAll('.info__section');

  expanders.forEach((expander) => {
    const trigger = expander.querySelector('.js-info-title');
    const content = expander.querySelector('.js-info-content');

    trigger.addEventListener('click', () => {
      // Close other expanders within the same collection
      // expanders.forEach((otherExpander) => {
      //   if (otherExpander !== expander) {
      //     const otherContent = otherExpander.querySelector('.js-info-content');
      //     const otherTrigger = otherExpander.querySelector('.title__trigger');

      //     otherContent.classList.remove('active');
      //     otherTrigger.classList.remove('active');
      //     otherExpander.classList.remove('active');
      //   }
      // });

      // Toggle the clicked expander
      content.classList.toggle('active');
      trigger.querySelector('.title__trigger').classList.toggle('active');
      expander.classList.toggle('active');
    });
  });
});